import CryptoJS from 'crypto-js';
import { getUrlParams } from '@/utils/env';

export const h5Id = '30001';
// 动态key 取当前域名前16位，不足16位在后面补0
const cryptoKey = getCryptoKey();
const cryptoIv = 'HtyGswhfiWPyCaLP';
const key = CryptoJS.enc.Utf8.parse(cryptoKey);
const iv = CryptoJS.enc.Utf8.parse(cryptoIv);

const isDevelopment = process.env.NODE_ENV === 'development';
const whiteDomain = ['h5-test.aibabyoffice.pro', 'localhost:3008', 'veiloza.com'];

function getCryptoKey() {
  if (process.env.NODE_ENV === 'development') {
    return 'h5-test.aibabyoffice.pro0000000000000000'.substring(0, 16);
  }

  if (typeof window === 'undefined') {
    return 'aRXJKhOdcneoc3Fw';
  }

  return `${window.location.host}0000000000000000`.substring(0, 16);
}

function debugEncrypt() {
  if (typeof window === 'undefined') {
    return;
  }
  if (!window.$$encrypt) {
    window.$$__encrypt = aesEncrypt;
  }
  if (!window.$$decrypt) {
    window.$$__decrypt = aesDecrypt;
  }
}

// debugEncrypt();

function debugLog(options, dataJson) {
  if (+getUrlParams('debug') === 2 && whiteDomain.includes(window?.location.host)) {
    try {
      console.group(
        `🔧【Request ${[options.method, options.requestType].filter(Boolean).join(' ')}】url：${options.url}`
      );
      const isGetMethod = options.method?.toLowerCase() === 'get';
      const params = isGetMethod ? options.getParams : options.data;

      if (params) {
        let reqParams = params;

        try {
          if (isGetMethod) {
            const ps = aesDecrypt(reqParams.v);
            const chatIndex = ps.indexOf('?');

            if (chatIndex !== -1) {
              const content = ps.substring(chatIndex + 1, ps.length);
              const getParams = Object.fromEntries(content.split('&').map((str) => str.split('=')));

              console.log(`[GET params]`, getParams);
            }
          } else {
            try {
              if (
                options.headers?.['Content-Type'] === 'application/x-www-form-urlencoded' ||
                options.requestType === 'form'
              ) {
                reqParams = Object.fromEntries(params.entries());
              }
            } catch (e) {
              reqParams = params;
            }

            const p = {};
            Object.keys(reqParams).forEach((key) => {
              if (reqParams.hasOwnProperty(key)) {
                if (key === 'file') {
                  p[key] = reqParams[key];
                } else {
                  p[key] = JSONParse(aesDecrypt(reqParams[key]));
                }
              }
            });

            console.log(`[${options.method} params]`, { ...p.v, ...p.vv });
          }
        } catch (e) {
          console.log(`解析失败`, e);
        }
      }
      console.log(`[${options.method} Response]`, dataJson);
      console.groupEnd();
    } catch (e) {}
  }
}

export function JSONStringify(data) {
  if (typeof data === 'object') {
    return JSON.stringify(data);
  }

  return data;
}

export function JSONParse(data) {
  if (typeof data !== 'string') {
    return data;
  }

  try {
    return JSON.parse(data);
  } catch (e) {
    return data;
  }
}

// 加密
export function aesEncrypt(str) {
  const encrypted = CryptoJS.AES.encrypt(JSONStringify(str), key, {
    iv
  });
  return encodeURIComponent(CryptoJS.enc.Base64.stringify(encrypted.ciphertext));
}

// 解密
export function aesDecrypt(base64Str) {
  if (typeof base64Str !== 'string') {
    return base64Str;
  }
  const decrypted = CryptoJS.AES.decrypt(
    { ciphertext: CryptoJS.enc.Base64.parse(decodeURIComponent(base64Str)) },
    key,
    { iv }
  );
  return decrypted.toString(CryptoJS.enc.Utf8);
}

function handleUrl(url) {
  const isAbsoluteApi = /^\/v\d+/.test(url); // 判断是否为v开头的url

  if (isAbsoluteApi) {
    return url;
  }

  try {
    const u = new URL(url);

    return u.pathname + u.search + u.hash;
  } catch (e) {
    return url;
  }
}

// 拼接 url get参数
function joinUrlParams(url, params) {
  if (!url) return '';
  if (!params) return url;
  if (Object.keys(params).length === 0) return url;

  const chat = url.indexOf('?') === -1 ? '?' : '&';
  const queryString = Object.keys(params)
    .map((key) => `${key}=${encodeURIComponent(params[key])}`)
    .join('&');

  return `${url}${chat}${queryString}`;
}

function handleReqParams(options) {
  const { method, requestType, data } = options;

  if (!data) {
    return null;
  }

  switch (method?.toLowerCase()) {
    case 'get':
      return null;
    case 'post':
    case 'put':
      if (requestType === 'form') {
        // data 为 FormData
        if (data.entries) {
          if ([...data.entries?.()].length === 0) {
            return null;
          }
          const formData = new FormData();
          const { file, ...otherParams } = Object.fromEntries(data.entries());

          if (file) {
            formData.append('file', file);
          }

          if (otherParams && Object.keys(otherParams).length) {
            formData.append('vv', aesEncrypt(otherParams));
          }

          return formData;
        } else {
          return { vv: aesEncrypt(data) };
        }
      }

      if (options.headers?.['Content-Type'] === 'application/x-www-form-urlencoded') {
        return {
          vv: aesEncrypt(typeof data === 'string' ? Object.fromEntries(new URLSearchParams(data)) : data)
        };
      }

      // 非 multipart/form-data 请求
      if (Object.keys(data).length === 0) {
        return null;
      }
      return {
        v: aesEncrypt(data)
      };
    default:
      return {
        vv: aesEncrypt(data)
      };
  }
}

export function randomStr(len = 6) {
  const str = Math.random().toString(36).slice(2); // 去掉 '0.'

  return str.substring(0, len || str.length);
}

// 处理请求加密
export function handleRequestDecrypt(url, options) {
  if (isDevelopment) {
    return {
      url,
      options
    };
  }

  const { params, method, headers } = options;
  const isGetMethod = method?.toLowerCase() === 'get';
  // const stripped = handleUrl(url).replace(/^\/v\d+\//, ''); // 去掉 /v{number}/
  const stripped = handleUrl(url).replace(/^\/v1\//, ''); // 去掉 /v1/
  const u = isGetMethod ? joinUrlParams(stripped, params) : stripped;
  const encryptedU = aesEncrypt(u);
  const reqParams = handleReqParams(options);
  const customHeaders = {
    appId: h5Id
  };

  return {
    url: `/v7/${randomStr()}?v=${encryptedU}`,
    options: {
      ...options,
      params: null,
      getParams: isGetMethod ? { v: encryptedU } : null,
      data: reqParams,
      headers: {
        ...headers,
        ...customHeaders
      }
    }
  };
}

// 处理请求返回体解密
export async function handleResponseDecrypt(response, options) {
  if (isDevelopment) {
    return response;
  }

  if (response.status === 200) {
    const cloned = response.clone();
    const encryptedText = await cloned.text(); // 获取原始加密字符串
    const text = encryptedText.replace(/^"([^"]*)"?$/, '$1'); // 去掉首尾的引号
    let decrypted;

    try {
      decrypted = aesDecrypt(text);
    } catch (e) {
      decrypted = text;
    }

    const dataJson = JSONParse(decrypted);

    handleLogin(dataJson);

    debugLog(options, dataJson);
    return dataJson;
  }

  debugLog(options, response);

  return response;
}

let hasLoginExpireModal = false;
const handleLogin = (e) => {
  //处理登录过期弹窗;
  if (e && e.error === 1407010004) {
    if (typeof window !== 'undefined' && !hasLoginExpireModal) {
      hasLoginExpireModal = true;
      try {
        // modalLoginExpire({
        //   content: e.msg
        // })
        //   .then(() => {
        //     hasLoginExpireModal = false;
        //     loginExpire(e.msg);
        //   })
        //   .catch(() => {
        //     hasLoginExpireModal = false;
        //     loginExpire(e.msg);
        //   });
      } catch (e) {
        hasLoginExpireModal = false;
      }
    }
  }
};
